<div class="center-header-info">
    <div class="context-column">
        <h3 class="consumer-info">
            {{ selectedConsumer?.name | titlecase }}
        </h3>
        <h4 *ngIf="selectedConsumer && selectedLocation" class="context-info">
            {{ selectedLocation.tag | titlecase }} - {{ selectedLocation.name | titlecase }}
        </h4>
    </div>
    <div class="search-column" *ngIf="selectedConsumer && selectedLocation">
        <emm-menu-search
            (clearSearchButtonClicked)="handleClearSearchButtonClicked()"
            (searchButtonClicked)="handleSearchButtonClicked()"
        ></emm-menu-search>
    </div>
</div>
